import{TextColumnSkeleton as e}from"./TextColumnSkeleton.js";import{MapColumnSkeleton as o}from"./MapColumnSkeleton.js";import{jsx as t,jsxs as n}from"react/jsx-runtime";import{styled as l}from"@mui/joy";import m from"@mui/joy/Stack";var s=l(m)`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({theme:e})=>e.spacing(2)};
  & > * {
    flex: 1;
  }
`,a=({loading:l,children:m,map:a,oneTextColumn:r})=>l?n(s,{children:[t(e,{sx:{flex:a?5:1}}),a&&!r?t(o,{sx:{flex:4}}):a||r?null:t(e,{})]}):m;export{s as InfoBoxRowSkeleton,a as InformationSkeleton};
//# sourceMappingURL=InformationSkeleton.js.map